import React, { Component } from 'react';
import { Jumbotron, Container } from 'reactstrap';
import AddSAVAgent from './add-sav-agent';
import ListSAVAgents from './list-sav-agents';
import ClearBox from './clear-box';
import { GET_SAV_AGENTS } from '../../query/query';
import { withApollo } from 'react-apollo';
import DeleteDuplicatedBox from './delete-duplicated-box';


class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      agents: [],
    };

    this.getAgents = this.getAgents.bind(this);
  }

  getAgents() {
    this.props.client.query({
      query: GET_SAV_AGENTS,
      fetchPolicy: 'no-cache',
    }).then(({ data }) => {
      this.setState({
        agents: data.savGetAgents,
      });
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  componentWillMount() {
    this.getAgents();
  }

  render() {
    return (
      <Jumbotron>
        <h3 className="display-4">
          Administration SAV
        </h3>
        <hr className="my-2" />
        <Container>
          <AddSAVAgent
            refresh={this.getAgents}
          />
          <ListSAVAgents
            agents={this.state.agents}
            refresh={this.getAgents}
          />
        </Container>
        <Container>
          <ClearBox/>
        </Container>
        <Container>
          <DeleteDuplicatedBox />
        </Container>

      </Jumbotron>
    );
  }
}

export default withApollo(AdminPage);



// WEBPACK FOOTER //
// ./src/components/admin/admin.js